// const axios = require('axios')


const Tipologia_Aziende = () =>  {
  
  const lista = ['carr','off', 'cnc', 'idra', 'elet', 'nego', 'moda', 'oss', 'altro']

  return lista
}
exports.Tipologia_Aziende = Tipologia_Aziende;

const Tipologia_Aziende_lungo = () =>  {
  
  const lista = ['Carrozzerie','Officine', 'CNC', 'Idraulici', 'Elettricisti', 'Negozi', 'Moda', 'Oss', 'Altro']

  return lista
}
exports.Tipologia_Aziende_lungo = Tipologia_Aziende_lungo;


const Tipologia_Aziende_colore = () =>  {
  // questo è fondamnetale per avere colori con tonalità variabiule
  const lista = ['hsla(352, 100%, 88%, 0.5)', 'hsla(332, 100%, 88%, 0.5)', 'hsla(312, 100%, 88%, 0.5)', 
                 'hsla(180, 100%, 88%, 0.5)', 'hsla(150, 100%, 88%, 0.5)', 
                 'hsla(280, 100%, 88%, 0.5)', 'hsla(250, 100%, 88%, 0.5)',
                 'hsla(100, 100%, 88%, 0.5)',  'hsla(150, 100%, 88%, 0.5)']

  return lista
}
exports.Tipologia_Aziende_colore = Tipologia_Aziende_colore;

//------------------------------------------------------------
